var map = {
	"./cat.svg": 120,
	"./dog.svg": 121,
	"./fox.svg": 122,
	"./koala.svg": 123,
	"./lion.svg": 124,
	"./owl.svg": 125,
	"./penguin.svg": 126,
	"./pig.svg": 127,
	"./raccoon.svg": 128,
	"./react.svg": 129,
	"./sheep.svg": 130
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images nonrecursive \.svg$
// module id = 229
// module chunks = 0